<template>
    <div id="inicio" class="container-fluid" v-smoothscroll="{ duration : 1000, callback: callback , context : undefined }">
        <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3 text-center contenedor" data-aos="fade">
                <h1>{{ title }}</h1>
                <hr>
                <h2>{{ subtitle }}</h2>
            </div>
            <!-- <img src="../assets/foto1.jpg" alt="" width="100%"> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'inicio',
    data() {
        return {
            title: 'WE ARE',
            subtitle: 'Synonym of innovation, evolution and growth'
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
    background-attachment: fixed;
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
}

h1 {
    font-weight: bold;
    color: white;
    text-align: center;
    font-size: 60pt;
}

h2 {
    font-size: 14pt;
    text-align: center;
    padding: 0px 20px;
    color: white;
}


hr {
    border-width: 2px;
    width: 20%;
    border-color: #f86d10;
}

.contenedor {
    position: relative;
    top: 475px;
}

.container-fluid {
    height: 100vh;
    margin: 0px;
    padding: 0px;
    background-image: url("../assets/foto1.jpg");
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

/* media */

@media screen and (max-width: 1450px){

.contenedor {
    position: relative;
    top: 270px !important;
}
}


/* tablet */

@media screen and (max-width: 991px) {
    h1{
        margin-top:170px;
    }
}



/* mobile */

@media screen and (max-width: 767px) {
    .container-fluid {
        background-attachment: unset;
    }
    
    hr{
        display: none;
    }

    h1{
        margin: 0px;
        padding: 0px;
    }

    h2{
        margin: 0px;
        padding: 0px;
    }
}

/*mobile horizontal*/
@media screen and (max-width: 737px){
    .contenedor{
        top:160px !important;
    }
}

/*smaller mobile horizontal*/
@media screen and (max-width: 569px){
    .contenedor{
        top: 70px !important;
    }
}


@media screen and (max-width: 415px) {

    .contenedor{
        top: 280px !important;
    }
}

@media screen and (max-width: 330px) {

    h1{
        font-size: 30pt;
        margin-top: -10px;
    }

    h2{
        margin: 0px;
        padding: 0px;
    }

    .contenedor{
        top: 260px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/inicio.vue